export enum CreatedVia {
    TEMPLATE = 'template',
    DOCUMENT = 'document',
}